import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

import {
  DOTENV,
  PACKAGE_VERSION,
  SENTRY_PROJECT,
  SENTRY_DSN,
  SENTRY_TRACES_SAMPLE_RATE,
} from 'src/constants';

console.debug('Running application with environment:', DOTENV);

Sentry.init({
  // cloud
  // dsn: 'https://005d96f03f2ca71d8ac005c4ae69a3e4@o4506025815769088.ingest.sentry.io/4506025823436800',

  // self-hosted
  dsn: SENTRY_DSN,

  // debug: true,

  // version format here should be aligned with the version in the Github Action
  release: `${SENTRY_PROJECT}@${PACKAGE_VERSION}`,

  environment: DOTENV,

  enabled: DOTENV === 'production' || DOTENV === 'staging',

  denyUrls: [/https?:\/\/localhost/],
  // allowUrls: [/https?:\/\/dashboard.skynettrading.com/],

  integrations: [
    Sentry.browserProfilingIntegration(),

    // Sentry.browserTracingIntegration(),
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),

    Sentry.replayIntegration(),
  ],
  beforeBreadcrumb: (breadcrumb) => {
    if (breadcrumb.category === 'console') {
      return null;
    }
    return breadcrumb;
  },

  beforeSend(event) {
    const filteredEvent = { ...event };

    if (filteredEvent.request) {
      delete filteredEvent.request.headers?.Authorization;
      delete filteredEvent.request.headers?.['x-fingerprint'];
      delete filteredEvent.request.cookies;
    }

    return filteredEvent;
  },

  // Performance Monitoring
  // Capture 100% of the transactions, reduce in production!
  tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,

  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // 'localhost',
    /^https:\/\/dashboard\.skynettrading\.com\//,
  ],

  // Session Replay
  // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysSessionSampleRate: 0.1,

  // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  replaysOnErrorSampleRate: 1.0,
});
